export default __webpack_public_path__ + "locales/uk-UA/HotkeysPanel.json?hash=266747b0024fead8b6c72b838741d0e5";